import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className='home'>
    </div>
    
  );
};

export default Home;
